<tui-root>
    <div class="p-0 font-dmSans min-h-screen">
        <app-header></app-header>
        <router-outlet />
        <app-footer />
    </div>
</tui-root>
